import { CurrencyType } from "@brg/api"

export enum OrderStatuses {
    created = 0,                    //заказ создан
    awaitingPayment = 1,            //заказ отправлен на оплату и не может быть изменен
    successAccepted = 2,            //оплата успешна
    failedRejected = 3,             //оплата провалена
    awaitingAcquiringPayment  = 4, //нужно взять из ордера ссылку на экваринг и перейти по ней для оплаты 
}

export const paymentMap = {
    [CurrencyType.PlayMoney]: 2,
    [CurrencyType.RealMoney]: 1,
    [CurrencyType.Cashback]: 3,
    [CurrencyType.RUB]: 0,
}

export interface CheckOutModalProps {
    isOpen: boolean
    close: () => void
    product?: any
    productId?: string
    paymentEntityType?: number
    handleClick?: () => void
    onPaymentSuccess?: () => void
    children?: any
    realPrice?: number
    competitionId?: string
    selectedProjectId?: string
}

// порядок выполнения коллбеков: onNotEnoughMoney, handleClick, onPaymentFail | onPaymentSuccess
export interface CheckOutProps {
    handleClick?: (props?: any) => void
    onPaymentSuccess?: (props?: any) => void
    onPaymentFail?: (props?: any) => void
    onNotEnoughMoney?: () => void
    getCustomSummary?: (props?: any) => void
    isBook?: boolean
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
}
import { CurrencyType } from "@brg/api"

export enum OrderStatuses {
    created = 0,                    //заказ создан
    awaitingPayment = 1,            //заказ отправлен на оплату и не может быть изменен
    successAccepted = 2,            //оплата успешна
    failedRejected = 3,             //оплата провалена
    awaitingAcquiringPayment  = 4, //нужно взять из ордера ссылку на экваринг и перейти по ней для оплаты 
}

export const paymentMap = {
    [CurrencyType.PlayMoney]: 2,
    [CurrencyType.RealMoney]: 1,
    [CurrencyType.Cashback]: 3,
    [CurrencyType.RUB]: 0,
}

export interface CheckOutModalProps {
    isOpen: boolean
    close: () => void
    product?: any
    productId?: string
    paymentEntityType?: number
    handleClick?: () => void
    onPaymentSuccess?: () => void
    children?: any
    realPrice?: number
    competitionId?: string
    selectedProjectId?: string
}

// порядок выполнения коллбеков: onNotEnoughMoney, handleClick, onPaymentFail | onPaymentSuccess
export interface CheckOutProps {
    handleClick?: (props?: any) => void
    onPaymentSuccess?: (props?: any) => void
    onPaymentFail?: (props?: any) => void
    onNotEnoughMoney?: () => void
    getCustomSummary?: (props?: any) => void
    isBook?: boolean
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
}
